"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonControlsButton = exports.CommonControlsText = exports.CommonControlsHyperlink = exports.LayoutControlsGridCol = exports.LayoutControlsGridLayout = exports.LayoutControlsPanel = exports.ApplicationWorkflowIsolationBar = void 0;
var React = require("react");
var csod = require("player-core");
var View_1 = require("./View");
var Panel_1 = require("player-layout-controls/controls/Panel");
Object.defineProperty(exports, "LayoutControlsPanel", { enumerable: true, get: function () { return Panel_1.Panel; } });
var GridLayout_1 = require("player-layout-controls/controls/GridLayout");
Object.defineProperty(exports, "LayoutControlsGridLayout", { enumerable: true, get: function () { return GridLayout_1.GridLayout; } });
var GridCol_1 = require("player-layout-controls/controls/GridCol");
Object.defineProperty(exports, "LayoutControlsGridCol", { enumerable: true, get: function () { return GridCol_1.GridCol; } });
var Hyperlink_1 = require("player-common-controls/controls/Hyperlink");
Object.defineProperty(exports, "CommonControlsHyperlink", { enumerable: true, get: function () { return Hyperlink_1.Hyperlink; } });
var Text_1 = require("player-common-controls/controls/Text");
Object.defineProperty(exports, "CommonControlsText", { enumerable: true, get: function () { return Text_1.Text; } });
var Button_1 = require("player-common-controls/controls/Button");
Object.defineProperty(exports, "CommonControlsButton", { enumerable: true, get: function () { return Button_1.Button; } });
var ApplicationWorkflowIsolationBar = (function (_super) {
    __extends(ApplicationWorkflowIsolationBar, _super);
    function ApplicationWorkflowIsolationBar(props) {
        var _this = _super.call(this, props) || this;
        _this._setState = _this._setState.bind(_this);
        _this._proxyEvent = _this._proxyEvent.bind(_this);
        _this.forceRender = _this.forceRender.bind(_this);
        _this.view = View_1.view.call(_this, _this.props);
        _this.state = {
            viewModel: __assign(__assign({}, _this.view.state), _this.props),
            isInit: false
        };
        _this._trackers = {};
        if (typeof csod.context.tracking !== 'undefined') {
            var monikerCallback_1 = function (moniker, eventName) {
                var evt = document.createEvent("Event");
                evt.initEvent("player-" + moniker + "-" + eventName, true, false);
                window.dispatchEvent(evt);
            };
            for (var reporter in csod.context.tracking) {
                var _loop_1 = function (moniker) {
                    var events = csod.context.tracking[reporter][moniker];
                    var _loop_2 = function (i, l) {
                        var event_1 = events[i];
                        var monikerKey = moniker + '.' + event_1;
                        if (typeof this_1._trackers[monikerKey] === 'undefined')
                            this_1._trackers[monikerKey] = function () { monikerCallback_1(moniker, event_1); };
                    };
                    for (var i = 0, l = events.length; i < l; i++) {
                        _loop_2(i, l);
                    }
                };
                var this_1 = this;
                for (var moniker in csod.context.tracking[reporter]) {
                    _loop_1(moniker);
                }
            }
        }
        return _this;
    }
    ApplicationWorkflowIsolationBar.prototype.componentDidMount = function () {
        var _this = this;
        this.view.initialize
            ? this.view.initialize(this.props)
                .then(function () {
                _this.view.mounted ? _this.view.mounted() : null;
                _this.setState({
                    isInit: true,
                    viewModel: __assign(__assign({}, _this.view.state), _this.props)
                });
            })
            : null;
    };
    ApplicationWorkflowIsolationBar.prototype.componentWillReceiveProps = function (props) {
        var _this = this;
        this.view.receivedProps
            ? this.view.receivedProps(props).then(function () { return _this._setState(_this.state.viewModel, _this.view.state, props); })
            : this._setState(this.state.viewModel, this.view.state, props);
    };
    ApplicationWorkflowIsolationBar.prototype.componentWillUnmount = function () {
        this.view.unmount ? this.view.unmount() : null;
    };
    ApplicationWorkflowIsolationBar.prototype.forceRender = function (cb) {
        this.setState({
            viewModel: __assign(__assign(__assign({}, this.state.viewModel), this.view.state), this.props)
        }, cb ? cb : function () { });
    };
    ApplicationWorkflowIsolationBar.prototype._setState = function (viewModel, viewState, props) {
        this.setState({ viewModel: __assign(__assign(__assign({}, viewModel), viewState), props) });
    };
    ApplicationWorkflowIsolationBar.prototype._proxyTrackEvent = function (moniker, eventID, eventName) {
        var params = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            params[_i - 3] = arguments[_i];
        }
        var args = [];
        for (var i = 3; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        var monikerKey = moniker + '.' + eventID;
        var monikerCallback = this._trackers[monikerKey] || function () { };
        return this._procesEvent(eventName, args, 4, monikerCallback);
    };
    ApplicationWorkflowIsolationBar.prototype._proxyEvent = function (eventName) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        var args = [];
        for (var i = 1; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        return this._procesEvent(eventName, args, 2, function () { });
    };
    ApplicationWorkflowIsolationBar.prototype._procesEvent = function (eventName, args, repeaterArgIndex, callback) {
        args = pushAndShiftArgs(args, repeaterArgIndex);
        if (typeof this.view.events[eventName] === 'function') {
            var self_1 = this;
            return function proxy() {
                var combinedArgs = [].slice.call(arguments).concat(args);
                var shouldRender = self_1.view.events[eventName].apply(self_1, combinedArgs);
                if (shouldRender !== false) {
                    csod.engine.commit();
                }
                csod.lastEventDate = new Date();
                callback();
            };
        }
        else {
            return function noFunc() {
                if (eventName) {
                    csod.logger.warn(eventName + ' is not a valid function. Please check for typos.');
                    csod.lastEventDate = new Date();
                }
                callback();
            };
        }
    };
    ApplicationWorkflowIsolationBar.prototype.render = function () {
        var _this = this;
        var PlayerRepeater = csod.engine.controls.Player.Repeater;
        var PlayerVisible = csod.engine.controls.Player.Visible;
        var PlayerSwitch = csod.engine.controls.Player.Switch;
        var $this = this;
        var root_handler = function () {
            return [React.createElement(Panel_1.Panel, { key: 0, paddingVertical: "Small", paddingHorizontal: "Medium", backgroundColor: "Grey20", roundedCorner: "All", children: [React.createElement(GridLayout_1.GridLayout, { key: 0, gutterHorizontal: "Small", colMainAxisAlignment: "SpaceBetween", colCrossAxisAlignment: "Middle", children: [React.createElement(GridCol_1.GridCol, { key: 0, width: "Auto", children: [React.createElement(GridLayout_1.GridLayout, { key: 0, gutterHorizontal: "Xsmall", gutterHorizontalForSm: "Medium", colMainAxisAlignment: "Start", children: [React.createElement(GridCol_1.GridCol, { key: 0, width: "Auto", children: [React.createElement(Hyperlink_1.Hyperlink, { key: 0, hasLinkStyle: true, type: "Action", isEnabled: $this.state.viewModel.isCancelBtnEnabled, tag: "btnCancel", role: "button", onClick: _this._proxyEvent("onCancel"), children: [React.createElement(Text_1.Text, { key: 0, color: "Light", text: $this.state.viewModel.cancelBtnText, weight: "SemiBold" })] })] }), React.createElement(GridCol_1.GridCol, { key: 1, width: "Auto", children: [React.createElement(Hyperlink_1.Hyperlink, { key: 0, hasLinkStyle: true, type: "Action", isEnabled: $this.state.viewModel.isSaveBtnEnabled, tag: "btnSave", role: "button", ariaLabel: $this.state.viewModel.saveBtnAriaLabel, onClick: _this._proxyEvent("onSave"), children: [React.createElement(Text_1.Text, { key: 0, color: "Light", text: $this.state.viewModel.saveBtnText, weight: "SemiBold" })] })] })] })] }), React.createElement(GridCol_1.GridCol, { key: 1, width: "Auto", children: [React.createElement(GridLayout_1.GridLayout, { key: 0, gutterHorizontal: "Xsmall", gutterHorizontalForSm: "Medium", colMainAxisAlignment: "End", children: [React.createElement(GridCol_1.GridCol, { key: 0, width: "Auto", isVisible: $this.state.viewModel.showPrev, children: [React.createElement(Button_1.Button, { key: 0, color: "Grey", text: $this.state.viewModel.backBtnText, tag: "btnBack", ariaLabel: $this.state.viewModel.backBtnAriaLabel, onClick: _this._proxyEvent("onBack") })] }), React.createElement(GridCol_1.GridCol, { key: 1, width: "Auto", isVisible: $this.state.viewModel.showNext, children: [React.createElement(Button_1.Button, { key: 0, color: "Primary", text: $this.state.viewModel.nextBtnText, tag: "btnNext", ariaLabel: $this.state.viewModel.nextBtnAriaLabel, onClick: _this._proxyEvent("onNext") })] }), React.createElement(GridCol_1.GridCol, { key: 2, width: "Auto", isVisible: $this.state.viewModel.showSubmit, children: [React.createElement(Button_1.Button, { key: 0, color: "Primary", text: $this.state.viewModel.submitBtnText, isDisabled: $this.state.viewModel.submitBtnDisabled, tag: "btnSubmit", onClick: _this._proxyEvent("onSubmit") })] })] })] })] })] })];
        };
        return (React.createElement("div", { className: "p-view-applicationworkflowisolationbar" }, this.state.isInit ? root_handler() : null));
    };
    ApplicationWorkflowIsolationBar.defaultProps = {
        currentPage: "", totalPages: "", reqId: "", fileUploadWidth: "", cancelBtnText: "", backBtnText: "", nextBtnText: "", submitBtnText: "", saveBtnText: "", saveBtnAriaLabel: "", backBtnAriaLabel: "", nextBtnAriaLabel: "", submitBtnDisabled: "",
        onNext: function () { }, onBack: function () { }, onSubmit: function () { }, onCancel: function () { }, onSave: function () { }
    };
    return ApplicationWorkflowIsolationBar;
}(React.Component));
exports.ApplicationWorkflowIsolationBar = ApplicationWorkflowIsolationBar;
function pushAndShiftArgs(args, repeaterArgIndex) {
    if (args[repeaterArgIndex] === 'repeaterArgs') {
        args.push(args.shift());
        args.push(args.shift());
        args.shift();
        pushAndShiftArgs(args, repeaterArgIndex);
    }
    return args;
}
if (!window["__LOCALES__"])
    window["__LOCALES__"] = {};
window["__LOCALES__"]["ApplicationWorkflowIsolationBar"] = ["CareerSite"];



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/.tmp/ApplicationWorkflowIsolationBar/ApplicationWorkflowIsolationBar.js
// module id = 571
// module chunks = 0